// In-progress Blocks/Junior workspaces live in sessionStorage (this tab only), scoped to the signed-in
// user, so a finished program never carries over to the next student on a shared school computer.
const PREFIX = "blocks_ws_";

export const draftOwnerId = (userId) => userId || "anon";
export const draftKey = (id, owner) => `${PREFIX}${draftOwnerId(owner)}_${id}`;

export const loadDraft = (id, owner) => {
  try {
    const raw = sessionStorage.getItem(draftKey(id, owner));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveDraft = (id, owner, state) => {
  try { sessionStorage.setItem(draftKey(id, owner), JSON.stringify(state)); } catch { /* quota */ }
};

export const clearDraft = (id, owner) => {
  try { sessionStorage.removeItem(draftKey(id, owner)); } catch { /* ignore */ }
};

const removeByPrefix = (store) => {
  try {
    const keys = [];
    for (let i = 0; i < store.length; i++) {
      const k = store.key(i);
      if (k && k.startsWith(PREFIX)) keys.push(k);
    }
    keys.forEach((k) => store.removeItem(k));
    return keys.length;
  } catch {
    return 0;
  }
};

export const clearAllDrafts = () => removeByPrefix(sessionStorage);

// Drafts used to be kept in localStorage keyed only by question - wipe them so old answers stop reappearing
export const purgeLegacyDrafts = () => removeByPrefix(localStorage);
